const errorCodeDic: any = {
    '001':'존재하지 않는 아이디 입니다.',
    '002':'비밀번호가 일치하지 않습니다.',
    '003':'오류가 발생 했습니다.',
    '005':'근로자 계정은 로그인 할 수 없습니다.',

}

export default errorCodeDic;
